<template>
    <md-icon class="md-icon-image" v-once>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 800 800">
            <title>Calendar</title>
            <g>
                <path fill="#FEBD69" d="M606.25,175H550v-60.938c0-7.766-6.297-14.063-14.063-14.063h-46.875c-7.766,0-14.063,6.296-14.063,14.063V175H325v-60.938c0-7.766-6.296-14.063-14.063-14.063h-46.875c-7.766,0-14.063,6.296-14.063,14.063V175h-56.25c-31.066,0-56.25,25.184-56.25,56.25v412.5c0,31.066,25.184,56.25,56.25,56.25h412.5c31.066,0,56.25-25.184,56.25-56.25v-412.5C662.5,200.184,637.316,175,606.25,175z M599.219,643.75H200.781c-3.883,0-7.031-3.148-7.031-7.031V287.5h412.5v349.219C606.25,640.602,603.103,643.75,599.219,643.75z M537.286,408.613L370.518,574.046c-5.514,5.469-14.417,5.434-19.888-0.08l-87.997-88.71c-5.469-5.514-5.434-14.417,0.08-19.888l26.624-26.409c5.514-5.469,14.417-5.434,19.887,0.081l51.684,52.103L491.07,362.024c5.514-5.47,14.417-5.435,19.888,0.079l26.409,26.623C542.836,394.24,542.8,403.145,537.286,408.613L537.286,408.613z"/>
            </g>
        </svg>
    </md-icon>
</template>

<script>
    import MdIcon from "../../../components/MdIcon/MdIcon";

    export default {
        name: 'GdCalendarIcon',
        components: {
            MdIcon
        }
    }
</script>
